import lodash from 'lodash'
const { hasIn, isFunction } = lodash
import moment from 'moment-timezone' // TODO: We should centralize our date handling and wrap libs

let dateFilterDefaultFormat: string | undefined

/**
 * Used to format dates as strings
 */
export function dateFilter(
  date: any,
  format?: string,
  ...rest: any
): moment.Moment | string | null {
  let result: moment.Moment | string | null = null
  const errs: any[] = []
  let obj: moment.Moment | undefined
  try {
    obj = moment(date)
  } catch (err) {
    errs.push(err)
  }
  if (obj) {
    const momentFunc = obj[format as keyof moment.Moment]
    try {
      if (hasIn(obj, format || '') && isFunction(momentFunc)) {
        result = (momentFunc as (this: moment.Moment) => string).apply(
          obj,
          rest,
        )
      } else {
        result = obj.format(format || dateFilterDefaultFormat)
      }
    } catch (err) {
      errs.push(err)
    }
  }
  if (errs.length) {
    return errs.join('\n')
  }
  return result
}

export function setDefaultFormat(format: string) {
  dateFilterDefaultFormat = format
}

export function toDate(date: string | null) {
  return date ? new Date(date) : new Date()
}
